import axios from "axios";

const token = process.env.REACT_APP_TOKEN; // lo stesso hardcoded token usato in Flask
const be_address = process.env.REACT_APP_BACKEND_ADDRESS;

export const checkHealth = async () => {
    try {
        const response = await axios.get(be_address + '/', {
            headers: { Authorization: `Bearer ${token}` },
            timeout: 5000
        });
        return response.status === 200;
    } catch {
        return false;
    }
};

export const getStrategies = async () => {
    try {
        const response = await axios.get(be_address + "/api/strategies", {
            headers: {
                Authorization: `Bearer ${token}`
            },
            timeout: 30000 // 30 secondi timeout (chiamata iniziale)
        });

        if (response.status === 200) {
            return response.data;
        }
        return null;
    } catch (error) {
        console.error('Error fetching strategies:', error.message);
        throw error; // Rilancia l'errore per gestirlo nel componente
    }
};

export const getSelectedSecurities = async (args, signal) => {
    try {
        const response = await axios.get(be_address + "/api/selected-securities", {
            headers: {
                Authorization: `Bearer ${token}`
            },
            params: {...args},
            signal: signal,
            timeout: 20000
        });

        if (response.status === 200) {
            return response.data[0];
        }
        return null;
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            console.log('Request canceled:', error.message);
        } else {
            console.error('Error fetching selected securities:', error.message);
            throw error;
        }
    }
};

export const getGapPercentage = async (args, signal) => {
    try {
        const response = await axios.get(be_address + "/api/gap-percentage", {
            headers: {
                Authorization: `Bearer ${token}`
            },
            params: {...args},
            signal: signal,
            timeout: 20000
        });

        if (response.status === 200) {
            return response.data;
        }
        return null;
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            console.log('Request canceled:', error.message);
        } else {
            console.error('Error fetching gap percentage:', error.message);
            throw error;
        }
    }
};

export const getFirstBar = async (args, signal) => {
    try {
        const response = await axios.get(be_address + "/api/first-bar", {
            headers: {
                Authorization: `Bearer ${token}`
            },
            params: {...args},
            signal: signal,
            timeout: 20000
        });

        if (response.status === 200) {
            return response.data;
        }
        return null;
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            console.log('Request canceled:', error.message);
        } else {
            console.error('Error fetching first bar:', error.message);
            throw error;
        }
    }
};

export const getSecondBar = async (args, signal) => {
    try {
        const response = await axios.get(be_address + "/api/second-bar", {
            headers: {
                Authorization: `Bearer ${token}`
            },
            params: {...args},
            signal: signal,
            timeout: 20000
        });

        if (response.status === 200) {
            return response.data;
        }
        return null;
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            console.log('Request canceled:', error.message);
        } else {
            console.error('Error fetching second bar:', error.message);
            throw error;
        }
    }
}
export const getTradeData = async (args, signal) => {
    try {
        const response = await axios.get(be_address + "/api/trade", {
            headers: {
                Authorization: `Bearer ${token}`
            },
            params: {...args},
            signal: signal,
            timeout: 20000
        });

        if (response.status === 200) {
            return response.data;
        }
        return null;
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            console.log('Request canceled:', error.message);
        } else {
            console.error('Error fetching trade data:', error.message);
            throw error;
        }
    }
}

export const getRecordsByDate = async (date, signal) => {
    try {
        const response = await axios.get(be_address + "/api/records-by-date", {
            headers: {
                Authorization: `Bearer ${token}`
            },
            params: {day: date},
            signal: signal,
            timeout: 20000
        });

        if (response.status === 200) {
            return response.data;
        }
        return null;
    } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
            console.log('Request canceled:', error.message);
        } else {
            console.error('Error fetching records by date:', error.message);
            throw error;
        }
    }
}